import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@design-system';
import { EngineDiffSlideOutContent } from './EngineDiffSlideOutContent';

interface EngineDiffDialogProps {
  fundingSourceId?: string;
  open: boolean;
  onClose: () => void;
}

// Legacy vs new claim-projection engine diff, shown in a dialog. Wizard-only
// tooling surfaced from the projection-details view.
export function EngineDiffDialog({ fundingSourceId, open, onClose }: EngineDiffDialogProps) {
  return (
    <Dialog open={open} onOpenChange={next => (!next ? onClose() : undefined)}>
      <DialogContent className="flex max-h-[90vh] w-[95vw] max-w-[1000px] flex-col overflow-hidden sm:max-w-[1000px]">
        <DialogHeader>
          <DialogTitle>Engine comparison</DialogTitle>
        </DialogHeader>
        <div className="overflow-auto">
          <EngineDiffSlideOutContent fundingSourceId={fundingSourceId} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
